var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86367 0.886421C6.15656 1.17932 6.15656 1.65419 5.86366 1.94708L3.06067 4.75004H11.75C12.1642 4.75004 12.5 5.08583 12.5 5.50004C12.5 5.91425 12.1642 6.25004 11.75 6.25004H3.06066L5.86366 9.05304C6.15656 9.34594 6.15656 9.82081 5.86366 10.1137C5.57077 10.4066 5.0959 10.4066 4.803 10.1137L0.71967 6.03037C0.579017 5.88972 0.5 5.69895 0.5 5.50004C0.5 5.30113 0.579019 5.11036 0.719673 4.96971L4.80301 0.886415C5.0959 0.593524 5.57077 0.593526 5.86367 0.886421Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default "/Frontend/static/media/arrow-left.b9414246f1b6f38bb952ae81cd886032.svg";
export { ForwardRef as ReactComponent };